import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { TravelCashService } from 'src/app/modules/travel-cash-advance/services/travel-cash/travel-cash.service';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { Travel } from 'src/app/models/travel';
import { liquidationUrl, travelCashUrl } from 'src/app/modules/shared/common/api';
import { TravelLiquidationAddComponent } from '../travel-liquidation-add/travel-liquidation-add.component';
import { TravelLiquidationViewComponent } from '../travel-liquidation-view/travel-liquidation-view.component';
import { TravelLiquiditionService } from '../../services/travel-liquidition/travel-liquidition.service';
import { User } from 'src/app/models/user';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-liquidation-list',
  templateUrl: './travel-liquidation-list.component.html',
  styleUrls: ['./travel-liquidation-list.component.scss']
})
export class TravelLiquidationListComponent implements OnInit {

  keyWords = {};
  newKeyWords = {};
  menuList = [
    {
      label:"Requestor",
      type:"input",
      name:"complete_name",
    },
    {
      label:"Date Submitted",
      type: 'date',
      name:"date_submitted",
      value: [],
    },
    {
      label:"Purpose",
      type:"input",
      name:"purpose",
    },
    {
      label:"Location",
      type:"input",
      name:"location",
    },
    {
      label:"Status",
      type:"select",
      name:"status",
      value: ["Closed", "Cancelled","Draft", "For 1st Approval", "For 2nd Approval","For Further Review", "Late Liquidation", "Rejected"].sort()
    }
  ];
  

  isNoResult: boolean = false;
  loading:boolean = false;
  isRole:boolean = false;
  isKeyWord:boolean = false;
  isMax:boolean = false;
  msgErr:any;
  params:any;
  keyTable = '';
  msg = "";
  res:any;

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: Travel;
  dialogConfig:any;
  departmentList:any;
  formGroup: FormGroup;
  user = new User();

  pipe = new DatePipe('en-US');

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public liquidationService: TravelLiquiditionService,
    public functionService: FunctionsService,
    public travelService: TravelService,
    private route: ActivatedRoute
  ) {
    this.isRole = this.user.getRole();
   }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      liquidation_no:['',null],
      travel_authorization_no:['',null],
      cash_advance_no:['',null],
      complete_name: ['',null],
      date_filed: ['',null],
      date_submitted:['',null],
      travel_reason:['',null],
      location: ['',null],
      purpose:['',null],
      status: ['',null],
      dashboard: ['',null],
      department_filter: ['',null],
      travel_type: ['',null],
    });

    this.keyWords = [];

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

    //check status param router if set
    this.route.queryParams.subscribe( params =>{

      if (params['email']) {
        this.params = params;
        this.formGroup.controls['liquidation_no'].setValue(params['email']);
        this.getFilter();
        return;
      } else if (params['status'] || params['dashboard'] || params['travel_type']) {
        this.formGroup.controls['status'].setValue(params.status);
        this.formGroup.controls['dashboard'].setValue(params.dashboard);
        this.formGroup.controls['travel_type'].setValue(params.travel_type);
        if (this.formGroup.controls['status'].value && this.formGroup.controls['dashboard'].value) {
          this.newKeyWords = {status: this.formGroup.controls['status'].value, dashboard: this.formGroup.controls['dashboard'].value}
        }
        this.getFilter();
      } else {
        this.keyWords = {};
        this.getList();
      }
    });

  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }
    if(this.formGroup.controls['date_submitted'].value !== '' && this.formGroup.controls['date_submitted'].value !== null){
      this.formGroup.controls['date_submitted'].setValue(this.pipe.transform(this.formGroup.controls['date_submitted'].value, 'yyyy-MM-dd'));
    }
    this.getList();
    if (Object.keys(this.newKeyWords).length > 0) {
      delete this.newKeyWords['dashboard'];
      this.keyWords = this.newKeyWords;
    } else {
      this.keyWords = [];
      this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
    }
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }  

    if(this.formGroup.controls['liquidation_no'].value !== null){
      param.push('liquidation_no='+encodeURIComponent(this.formGroup.controls['liquidation_no'].value));
    }

    if(this.formGroup.controls['travel_authorization_no'].value !== null){
      param.push('travel_authorization_no='+encodeURIComponent(this.formGroup.controls['travel_authorization_no'].value));
    }

    if(this.formGroup.controls['complete_name'].value !== null){
      param.push('complete_name='+this.formGroup.controls['complete_name'].value);
    }
    
    if(this.formGroup.controls['date_submitted'].value !== null){
      param.push('date_submitted='+this.formGroup.controls['date_submitted'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      param.push('status='+this.formGroup.controls['status'].value);
    }

    if(this.formGroup.controls['dashboard'].value !== null){
      param.push('dashboard='+this.formGroup.controls['dashboard'].value);
    }

    if(this.formGroup.controls['purpose'].value !== null){
      param.push('purpose='+this.formGroup.controls['purpose'].value);
    }

    if(this.formGroup.controls['location'].value !== null){
      param.push('location='+this.formGroup.controls['location'].value);
    }

    if(this.formGroup.controls['department_filter'].value !== null){
      param.push('department_filter='+this.formGroup.controls['department_filter'].value);
    }

    if(this.formGroup.controls['travel_type'].value !== null){
      param.push('travel_type='+this.formGroup.controls['travel_type'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.liquidationService.url = liquidationUrl +''+ queryString;
    this.liquidationService.getFilter().subscribe(res=>{
      if (res.data) {
        this.travel = new Travel(res.data);
      } else {
        this.isNoResult = true;
      }
      if (this.params) {
        if (res.data[0]) {
          this.openDetail(res.data[0]);
          this.params = '';
        }
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    },(err => {
      console.log(err);
    }));
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelLiquidationViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  createDialog(res) {
    this.loading = true;
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelLiquidationAddComponent, this.dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getList();
        }
    });
    this.loading = false;
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }

  close() {
    this.msg = "";
    this.res = null;
  }

  delete() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.liquidationService.updateStatus(this.res.id,data).subscribe(res=>{
      this.getList();
      this.loading = false;
      this.msg = "";
      this.res = null;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          message: res['message']
        }
      });
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  /**
   * Delete Travel Request Data
   */
  deleteAsDraft(res) {
    this.res = res;
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }

}
